import { createFileRoute, Link } from "@tanstack/react-router";
import { Door, DoorActions, DoorButton, DoorText } from "@optymyse/suite-ui";
import { PRODUCT_KEY } from "../../shared/product";
import { strings } from "../lib/strings";

/**
 * Where the sign-in callback sends a person of a region Link does not serve yet: one Impa has added
 * before Link has a store there (SERVED_REGIONS, src/shared/schemas/region.ts). Nothing about them was
 * written; the suite's door only says why they are not in.
 */
function RegionUnavailablePage() {
  return (
    <Door product={PRODUCT_KEY} title={strings.auth.regionUnavailable.title} pip="locked">
      <DoorText>{strings.auth.regionUnavailable.body}</DoorText>
      <DoorActions>
        <DoorButton asChild variant="quiet">
          <Link to="/">{strings.auth.regionUnavailable.back}</Link>
        </DoorButton>
      </DoorActions>
    </Door>
  );
}

export const Route = createFileRoute("/unavailable")({ component: RegionUnavailablePage });
